import { SliderSettings } from "../../../../Shared/components/CardLayout/SliderSettings";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ModuleNames } from "../../../OrderFlowProvider/OrderFlowTypes";
import { QuestionContentAlignment, QuestionType, } from "./Questions-Types";
export const useQuestionsModule = (sequenceNumber) => {
    var _a;
    const { store, dispatch } = useOrderFlow();
    /**
     * @param question
     * @param answer
     */
    const HandleAnswerSet = (question, answer) => {
        const currentQuestionSKU = question.QuestionSKU;
        let cartQuestionAnswers = store.cart.questionAnswers;
        let currentAnswer = cartQuestionAnswers.find((answer) => answer.QuestionSKU === currentQuestionSKU);
        const index = currentAnswer ? cartQuestionAnswers.indexOf(currentAnswer) : -1;
        if (!currentAnswer) {
            currentAnswer = {
                QuestionSKU: currentQuestionSKU,
                Answer: question.DefaultValue,
            };
        }
        // Check if current answer has upcharge attached
        const oldAnswerHasUpcharge = DoesAnswerHaveUpcharge(question, currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.Answer);
        // Handle open text answers
        currentAnswer.Answer = answer;
        // Check if new answer has upcharge attached
        const newAnswerHasUpcharge = DoesAnswerHaveUpcharge(question, answer);
        // Was There a change in upcharge?
        const upchargeChange = oldAnswerHasUpcharge || newAnswerHasUpcharge;
        // Get upcharges for the current answer
        const newAnswerObject = maybeAddUpchargesToAnswers(question, currentAnswer.Answer);
        if (index !== -1) {
            cartQuestionAnswers[index] = newAnswerObject;
        }
        else {
            cartQuestionAnswers.push(newAnswerObject);
        }
        // Prepare additional items with upcharges for the cart
        const cartQuestionAnswersWithUpcharges = cartQuestionAnswers
            .filter((answer) => answer.UpchargeItemName && answer.UpchargePrice && answer.UpchargePrice > 0)
            .map((answer) => ({
            Description: answer.UpchargeItemName,
            Price: answer.UpchargePrice,
        }));
        // Only dispatch upcharge changes if old or new question have upcharge
        if (upchargeChange) {
            dispatch({ type: ActionTypes.SET_MISC_CHARGES, payload: cartQuestionAnswersWithUpcharges });
        }
        dispatch({ type: ActionTypes.SET_QUESTION_ANSWERS, payload: cartQuestionAnswers });
    };
    /**
     * @param question
     * @param answer
     */
    const DoesAnswerHaveUpcharge = (question, answer) => {
        var _a;
        return ((_a = question.AnswerOptions) === null || _a === void 0 ? void 0 : _a.some((qa) => qa.Upcharge && qa.Upcharge > 0 && qa.Value === answer))
            ? true
            : (!!question.ToggleUpcharge && question.ToggleUpchargeApplyState === answer) || false;
    };
    /**
     * @param questionSKU
     * @param answer
     */
    const GetCurrentAnswer = (question) => {
        let currentVal = question.DefaultValue;
        const cartQuestionAnswers = store.cart.questionAnswers;
        const currAnswer = cartQuestionAnswers.find((answer) => answer.QuestionSKU === question.QuestionSKU);
        if (currAnswer) {
            currentVal = currAnswer.Answer;
        }
        if (question.QuestionType === QuestionType.Numeric && isNaN(Number(currentVal))) {
            currentVal = "0";
        }
        return currentVal;
    };
    const AnswerIsTrue = (answer) => {
        return (answer === null || answer === void 0 ? void 0 : answer.toString().toLocaleLowerCase().trim()) === "true";
    };
    const AnswersAreEqual = (answer1, answer2) => {
        let numVal1 = Number(answer1);
        let numVal2 = Number(answer2);
        return answer1 === answer2 || (!isNaN(numVal1) && !isNaN(numVal2) && numVal1 === numVal2);
    };
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((m) => m.ModuleName === ModuleNames.QUESTIONS && m.Sequence === sequenceNumber && m.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    const { GridSpacing, IsGridLayout, ScreenLG, ScreenMD, ScreenSM, ScreenXS, AlignContent } = moduleConfig;
    const shouldAlignGrid = AlignContent == QuestionContentAlignment.Center ? true : false;
    const buttonsLayout = {
        isGridLayout: IsGridLayout,
        sliderSettings: SliderSettings(ScreenLG, ScreenMD, ScreenSM, ScreenXS),
        cardsPerRowXS: ScreenXS,
        cardsPerRowSM: ScreenSM,
        cardsPerRowMD: ScreenMD,
        cardsPerRowLG: ScreenLG,
        gridSpacing: GridSpacing,
        // Questions module uses AlignContent config instead of CenterCards
        CenterCards: shouldAlignGrid,
    };
    return {
        answersInCart: store.cart.questionAnswers,
        HandleAnswerSet,
        GetCurrentAnswer,
        AnswerIsTrue,
        AnswersAreEqual,
        moduleConfig,
        buttonsLayout,
    };
};
export function maybeAddUpchargesToAnswers(question, answer) {
    const questionAnswerOptionsFromConfig = question.AnswerOptions;
    const questionSKU = question.QuestionSKU;
    const newAnswerObject = {
        QuestionSKU: questionSKU,
        Answer: answer,
    };
    // Check choice answers (buttons and dropdowns) for attached upcharges
    const answerDataFromConfig = questionAnswerOptionsFromConfig.filter((option) => option.Value == answer);
    if (answerDataFromConfig) {
        answerDataFromConfig.forEach((a) => {
            if (a.Upcharge) {
                newAnswerObject.UpchargeItemName = questionSKU;
                newAnswerObject.UpchargePrice = a.Upcharge;
            }
        });
    }
    // Handle toggle switches and checkboxes for attached upcharges
    if (question.ToggleUpcharge && question.ToggleUpchargeApplyState) {
        if (question.ToggleUpchargeApplyState === answer) {
            newAnswerObject.UpchargeItemName = questionSKU;
            newAnswerObject.UpchargePrice = question.ToggleUpcharge;
        }
    }
    return newAnswerObject;
}
